import { useState, useEffect, useCallback } from 'react'
import { ActualMonthlyReport } from '@/lib/db/schema/actuals'
import { ActualMonthInput } from '@/lib/validation/actuals'

export function useActuals(businessId: string | undefined) {
  const [actuals, setActuals] = useState<ActualMonthlyReport[]>([])
  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  const fetchActuals = useCallback(async () => {
    if (!businessId) {
      setIsLoading(false)
      return
    }
    setIsLoading(true)
    setError(null)
    try {
      const res = await fetch(`/api/businesses/${businessId}/actuals`)
      const json = await res.json() as any
      if (res.ok && json.success) {
        setActuals(json.data)
      } else {
        setError(json.error?.message || 'Failed to fetch actuals')
      }
    } catch (err: any) {
      setError(err.message || 'Network error')
    } finally {
      setIsLoading(false)
    }
  }, [businessId])

  useEffect(() => {
    fetchActuals()
  }, [fetchActuals])

  const saveActual = async (payload: ActualMonthInput) => {
    if (!businessId) return { success: false, error: 'No business ID' }
    const res = await fetch(`/api/businesses/${businessId}/actuals`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    })
    const json = await res.json() as any
    if (res.ok && json.success) {
      fetchActuals()
      return { success: true, data: json.data }
    }
    return { success: false, error: json.error?.message || 'Failed to save actual report' }
  }

  return { actuals, isLoading, error, refetch: fetchActuals, saveActual }
}
